import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-content">
        <h2 className="greeting">Hi there, I'm</h2>
        <h1 className="name">Marcus Yap<span className="cursor">|</span></h1>
        
        <div className="roles-wrapper">
          <p className="role">Final Year CS Student @ NUS</p>
          <span className="dot">•</span>
          <p className="role">AI / ML Enthusiast</p>
          <span className="dot">•</span>
          <p className="role">Cyber Risk Explorer</p>
        </div>
        
        <p className="bio">
          I'm a computer science student with a second major in <strong>Quantitative Finance</strong>. 
          Experienced in Cyber Risk & Governance, risk quantification exploration, and automation, 
          with a strong track record across <strong>ML/NLP, AI search, and Deep RL.</strong>
        </p>

        <div className="cta-container">
          <a href="#projects" className="primary-btn" style={{display: 'inline-block', textAlign: 'center'}}>View Projects</a>
          <a href="#contact" className="secondary-btn" style={{display: 'inline-block', textAlign: 'center'}}>Get in Touch</a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
